import React from 'react';
import ChannelForm from '../ChannelForm';

import './channelEdit.css';

export function ChannelEdit() {
    return <ChannelForm isEdit={true} />;
}
